import React, { useCallback, useEffect, useState } from "react";
import {
  SharedSchedule,
  SharedSchedulesContext
} from "@/context/SharedSchedulesContext";
import useApi from "@/hooks/useApi";

export function SharedSchedulesProvider(props: { children: React.ReactNode }) {
  const api = useApi();
  const [loading, setLoading] = useState(true);
  const [schedules, setSchedules] = useState<SharedSchedule[]>([]);

  const reload = useCallback(async () => {
    try {
      const response = await api.messaging.get("SharedSchedule");
      const data = await response.json();
      setSchedules(Array.isArray(data) ? data : []);
    } catch {
      setSchedules([]);
    } finally {
      setLoading(false);
    }
  }, [api.messaging]);

  useEffect(() => {
    reload();
  }, [reload]);

  return (
    <SharedSchedulesContext.Provider value={{ schedules, loading, reload }}>
      {props.children}
    </SharedSchedulesContext.Provider>
  );
}
